import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { SalaryApiRecentSubmission } from './types/SalaryApiRecentSubmission';

type ApiResponse = {
  recentSubmissions: SalaryApiRecentSubmission[];
};

function mapResponse(response: ApiResponse) {
  return response.recentSubmissions;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/salary-surveys/recent-submissions',
  mapResponse,
});

// Exports

export const useSalaryApiFetchRecentSubmissions = endpoint.createUseFetchHook();

export const salaryApiIsomorphicFetchRecentSubmissions =
  endpoint.createIsomorphicFetchFn();
